<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">Merchant Relationship Officer</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">Merchant Relationship Officer</p>
            <div class="description-container">
                <p class="subtitle">Job Descriptions</p>
                <ul class="requirement-list">
                    <li>Oversee merchant/agent/corporate customers:</li>
                    <li class="list-details"> Provide training to merchant/agent and customer to ensure that quality is met our standard.</li>
                    <li class="list-details"> Facilitate reliable delivery of merchandising materials, POS and paper rolls to merchant/agent.</li>
                    <li class="list-details"> Manage merchant/agent to ensure those necessary customer documents are returned within the set timeline if required.</li>
                    <li class="list-details"> Handle merchant/agent and customer questions.d</li>
                    <li class="list-details"> Gather feedback from merchant and customer to develop recommended solutions.</li>
                    <li class="list-details"> Follow call card consistently according to standard working procedure.</li>
                    <li class="list-details"> Provide training to merchant/agent and customer to ensure that quality is met Pi Pay standard</li>
                    <li class="list-details"> Ensure the quality of the network for merchant/agent and customer satisfaction</li>
                </ul>
                <ul class="requirement-list">
                    <li>Marketing Related:</li>
                    <li class="list-details"> Promote and position U-Pay marketing and merchandising materials according to standard</li>
                    <li class="list-details"> To ensure merchandising materials is well maintained and up-to-date.</li>
                    <li class="list-details"> Monitor and escalate any upcoming promotion which run by merchants.</li>
                    <li class="list-details"> Monitor and report on competitive offerings in the market.</li>
                    <li class="list-details"> GMaintain and prepare reporting for the assigned areas.</li>
                </ul>
                <p class="salary">SALARY: NEGOTIABLE</p>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 25% 3% 25%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 8%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 0% 5% 0%;

        .list-details {
            margin-bottom: 0.5%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}

.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>
